import * as React from 'react';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Opgave } from '../../models/Opgave';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import OpgaveEdit from './OpgaveEdit';
import { Redirect } from 'react-router-dom';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Spinner } from '../../uiComponents/Spinner';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { OpgaveAfsnit } from '../../models/OpgaveAfsnit';
import { Delopgave } from '../../models/Delopgave';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { MultipleChoiceSpoergsmaal } from '../../models/MultipleChoiceSpoergsmaal';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';
import { MultipleChoiceSvarmulighed } from '../../models/MultipleChoiceSvarmulighed';
import { isNullOrUndefined } from '../../infrastructure/ValidationHelper';
import OpgavePreview from './OpgavePreview';
import { DelopgaveBedoemmelsesFaktor } from '../../models/DelopgaveBedoemmelsesFaktor';
import { OpgavenBedoemmesEfterEnum } from '../../models/enums/OpgavenBedoemmesEfterEnum';

interface OpgaveContainerProps extends RouteComponentProps<any> {
}

interface OpgaveContainerState {
    opgave?: Opgave;
    OftestStilledeSpoergsmaalEditorState: EditorState;
    afsnitEditorStates: EditorState[];
    delopgaveEditorStates: EditorState[];
    validationResult?: ValidationResult;
    isSaved: boolean;
    isNew: boolean;
    isSubmitting: boolean;
    previewState: boolean;
}

class OpgaveContainer extends React.Component<OpgaveContainerProps, OpgaveContainerState> {
    constructor(props: OpgaveContainerProps) {
        super(props);

        this.state = {
            opgave: undefined,
            OftestStilledeSpoergsmaalEditorState: EditorState.createEmpty(),
            afsnitEditorStates: [],
            delopgaveEditorStates: [],
            validationResult: new ValidationResult(),
            isSaved: false,
            isNew: true,
            isSubmitting: false,
            previewState: false
        };

        this.onOpgaveSave = this.onOpgaveSave.bind(this);
        this.onOpgaveSaved = this.onOpgaveSaved.bind(this);
        this.onOpgaveChanged = this.onOpgaveChanged.bind(this);
        this.onOpgaveEditorChange = this.onOpgaveEditorChange.bind(this);
        // this.onOpgaveDelete = this.onOpgaveDelete.bind(this);
        this.addAfsnit = this.addAfsnit.bind(this);
        this.onAfsnitChanged = this.onAfsnitChanged.bind(this);
        this.onAfsnitEditorChange = this.onAfsnitEditorChange.bind(this);
        this.removeAfsnit = this.removeAfsnit.bind(this);
        this.addDelopgave = this.addDelopgave.bind(this);
        this.onDelopgaveChanged = this.onDelopgaveChanged.bind(this);
        this.onDelopgaveResultatEnumChanged = this.onDelopgaveResultatEnumChanged.bind(this);
        this.onDelopgaveEditorChange = this.onDelopgaveEditorChange.bind(this);
        this.removeDelopgave = this.removeDelopgave.bind(this);
        this.addSpoergsmaal = this.addSpoergsmaal.bind(this);
        this.onSpoergsmaalChanged = this.onSpoergsmaalChanged.bind(this);
        this.removeSpoergsmaal = this.removeSpoergsmaal.bind(this);
        this.addSvarmulighed = this.addSvarmulighed.bind(this);
        this.onSvarmulighedChanged = this.onSvarmulighedChanged.bind(this);
        this.removeSvarmulighed = this.removeSvarmulighed.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);
        this.addBedoemmelsesFaktor = this.addBedoemmelsesFaktor.bind(this);
        this.removeBedoemmelsesFaktor = this.removeBedoemmelsesFaktor.bind(this);
        this.onBedoemmelsesFaktorChanged = this.onBedoemmelsesFaktorChanged.bind(this);
    }

    componentDidMount() {
        let self = this;
        let apiCaller = createApiCaller();
        let param = this.props.match.params.id;
        this.setState({ isNew: param === 'ny' ? true : false });

        if (param === 'ny') {
            let newOpgave = new Opgave();
            this.setState({ opgave: newOpgave });
        } else {
            let opgavePromis = apiCaller.getOpgave(param);
            opgavePromis.then(function (json: Opgave) {
                json.delopgaver.forEach((d, i) => {
                    let editorState = EditorState.createEmpty();
                    if (!isNullOrUndefined(d.indhold)) {
                        editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(d.indhold)));
                    }
                    self.state.delopgaveEditorStates.push(editorState);
                });
                json.opgaveAfsnit.forEach((a, i) => {
                    let editorState = EditorState.createEmpty();
                    if (!isNullOrUndefined(a.indhold)) {
                        editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(a.indhold)));
                    }
                    self.state.afsnitEditorStates.push(editorState);
                });
                let OftestStilledeSpoergsmaalEditorState = EditorState.createEmpty();
                if (!isNullOrUndefined(json.oftestStilledeSpoergsmaalIndhold)) {
                    OftestStilledeSpoergsmaalEditorState = EditorState.createWithContent(convertFromRaw(JSON.parse(json.oftestStilledeSpoergsmaalIndhold)));
                }
                self.setState({
                    OftestStilledeSpoergsmaalEditorState: OftestStilledeSpoergsmaalEditorState,
                    opgave: json
                });
            });
        }
    }

    onOpgaveSave() {
        let self = this;
        this.setState({ isSubmitting: true });
        let param = this.props.match.params.id;
        let opgave = this.getOpgave();

        if (opgave.delopgaver) {
            opgave.delopgaver.forEach(d => { 

                if (Number(d.opgavenBedoemmesEfter) !== OpgavenBedoemmesEfterEnum.HoejereErBedre && Number(d.opgavenBedoemmesEfter) !== OpgavenBedoemmesEfterEnum.Valgmuligheder) {
                    d.opgavenBedoemmesEfter = 0;
                }
            });
        }

        let notificationMessage = 'Opgaven er blevet ';

        if (param === 'ny') {
            var createOpgavePromise = createApiCaller().createOpgave(opgave);
            createOpgavePromise.then(function (validationResult: ValidationResult) {
                self.onOpgaveSaved(validationResult, notificationMessage + 'oprettet');
            });
        } else {
            var updateOpgavePromise = createApiCaller().updateOpgave(opgave);
            updateOpgavePromise.then(function (validationResult: ValidationResult) {
                self.onOpgaveSaved(validationResult, notificationMessage + 'opdateret');
            });
        }
    }

    onOpgaveSaved(validationResult: ValidationResult, notificationMessage: string) {
        this.setState({ validationResult: validationResult, isSaved: validationResult.isValid ? true : false, isSubmitting: false });
        if (validationResult.isValid) {
            NotificationQueue.push(new NotificationData(notificationMessage, '', 'success'));
        }
    }

    onOpgaveChanged(fieldName: string, value: any) {
        let opgave = this.getOpgave();
        opgave[fieldName] = value;

        this.setState({ opgave: opgave });
    }

    onOpgaveEditorChange(editorState: EditorState) {
        this.setState({ OftestStilledeSpoergsmaalEditorState: editorState });

        let raw = convertToRaw(editorState.getCurrentContent());
        let opgave = this.state.opgave;
        if (opgave !== undefined) {
            opgave.oftestStilledeSpoergsmaalIndhold = JSON.stringify(raw);
        }

        this.setState({ OftestStilledeSpoergsmaalEditorState: editorState, opgave: opgave });

    }

    addAfsnit() {
        let afsnit = new OpgaveAfsnit();
        let newState = this.state;

        if (newState.opgave !== undefined) {
            if (newState.opgave.opgaveAfsnit === undefined) {
                newState.opgave.opgaveAfsnit = [];
            }
            newState.opgave.opgaveAfsnit.push(afsnit);
            newState.afsnitEditorStates.push(EditorState.createEmpty());

            this.setState(newState);
        }
    }

    onAfsnitChanged(fieldName: string, value: any, index: number) {
        let newState = this.state;
        if (newState.opgave !== undefined) {
            newState.opgave.opgaveAfsnit[index][fieldName] = value;
            this.setState(newState);
        }
    }

    onAfsnitEditorChange(editorState: EditorState, index: number) {
        let states = this.state.afsnitEditorStates;
        states[index] = editorState;

        let raw = convertToRaw(editorState.getCurrentContent());
        let opgave = this.state.opgave;
        if (opgave !== undefined) {
            opgave.opgaveAfsnit[index].indhold = JSON.stringify(raw);
        }

        this.setState({ afsnitEditorStates: states, opgave: opgave });
    }

    removeAfsnit(index: number) {
        let newState = this.state;
        if (newState.opgave !== undefined && index > -1) {
            newState.opgave.opgaveAfsnit.splice(index, 1);
            newState.afsnitEditorStates.splice(index, 1);
            this.setState(newState);
        }
    }

    addDelopgave() {
        let delopgave = new Delopgave();

        let newState = this.state;

        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver === undefined) {
                newState.opgave.delopgaver = [];
            }
            newState.opgave.delopgaver.push(delopgave);
            newState.delopgaveEditorStates.push(EditorState.createEmpty());

            this.setState(newState);
        }
    }

    onDelopgaveChanged(fieldName: string, value: any, index: number) {
        let newState = this.state;
        if (newState.opgave !== undefined) {
            newState.opgave.delopgaver[index][fieldName] = value;
            this.setState(newState);
        }
    }

    onDelopgaveResultatEnumChanged(fieldName: string, value: any, index: number) {
        let newState = this.state;
        let castedValue = Number(value);
        if (newState.opgave !== undefined) {
            newState.opgave.delopgaver[index][fieldName] = castedValue;

            if (castedValue !== ResultatAngivesIEnum.MultipleChoice) {
                newState.opgave.delopgaver[index].multipleChoiceSpoergsmaal = [];
            }

            this.setState(newState);
        }
    }

    onDelopgaveEditorChange(editorState: EditorState, index: number) {
        let states = this.state.delopgaveEditorStates;
        states[index] = editorState;

        let raw = convertToRaw(editorState.getCurrentContent());
        let opgave = this.state.opgave;
        if (opgave !== undefined) {
            opgave.delopgaver[index].indhold = JSON.stringify(raw);
        }

        this.setState({ delopgaveEditorStates: states, opgave: opgave });
    }

    removeDelopgave(index: number) {
        let newState = this.state;
        if (newState.opgave !== undefined && index > -1) {
            newState.opgave.delopgaver.splice(index, 1);
            newState.delopgaveEditorStates.splice(index, 1);
            this.setState(newState);
        }
    }

    addSpoergsmaal(delopgaveIndex: number) {
        let multipleChoiceSpoergsmaal = new MultipleChoiceSpoergsmaal();
        let newState = this.state;

        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                let delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.multipleChoiceSpoergsmaal === undefined) {
                    delopgave.multipleChoiceSpoergsmaal = [];
                }

                delopgave.multipleChoiceSpoergsmaal.push(multipleChoiceSpoergsmaal);

                this.setState(newState);
            }
        }
    }

    onSpoergsmaalChanged(fieldName: string, value: any, index: number, delopgaveIndex: number) {
        const newState = this.state;
        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                const delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
                    if (delopgave.multipleChoiceSpoergsmaal !== undefined) {

                        delopgave.multipleChoiceSpoergsmaal[index][fieldName] = value;
                        this.setState(newState);
                    }
                }
            }
        }
    }

    removeSpoergsmaal(index: number, delopgaveIndex: number) {
        const newState = this.state;
        if (newState.opgave !== undefined && index > -1) {

            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                const delopgave = newState.opgave.delopgaver[delopgaveIndex];
                delopgave.multipleChoiceSpoergsmaal.splice(index, 1);
                this.setState(newState);
            }
        }
    }

    addBedoemmelsesFaktor(delopgaveIndex: number) {
        const delopgaveBedoemmelsesFaktor = new DelopgaveBedoemmelsesFaktor();
        const newState = this.state;

        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                const delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.delopgaveBedoemmelsesFaktorer === undefined) {
                    delopgave.delopgaveBedoemmelsesFaktorer = [];
                }

                delopgave.delopgaveBedoemmelsesFaktorer.push(delopgaveBedoemmelsesFaktor);

                this.setState(newState);
            }
        }
    }

    // delopgave.OpgavenbedoemmesEfter konverteres til en int ellers fejler sammenligningen med OpgavenBedoemmesEfterEnum 
    onBedoemmelsesFaktorChanged(fieldName: string, value: any, index: number, delopgaveIndex: number) {
        const newState = this.state;
        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                const delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if ((Number(delopgave.opgavenBedoemmesEfter) === OpgavenBedoemmesEfterEnum.HoejereErBedre ||
                    Number(delopgave.opgavenBedoemmesEfter) === OpgavenBedoemmesEfterEnum.LavereErBedre) &&
                    (delopgave.resultatetAngivesI === ResultatAngivesIEnum.Heltal ||
                        delopgave.resultatetAngivesI === ResultatAngivesIEnum.Kommatal) && delopgave.delopgaveBedoemmelsesFaktorer !== undefined) {
                    delopgave.delopgaveBedoemmelsesFaktorer[index][fieldName] = value;
                    this.setState(newState);
                }
            }
        }
    }

    removeBedoemmelsesFaktor(index: number, delopgaveIndex: number) {
        const newState = this.state;
        if (newState.opgave !== undefined && index > -1) {

            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                const delopgave = newState.opgave.delopgaver[delopgaveIndex];
                delopgave.delopgaveBedoemmelsesFaktorer.splice(index, 1);
                this.setState(newState);
            }
        }
    }

    addSvarmulighed(delopgaveIndex: number, multipleChoiceSpoergsmaalIndex: number) {
        let multipleChoiceSvarmulighed = new MultipleChoiceSvarmulighed();
        let newState = this.state;

        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                let delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex] !== undefined) {
                    let multipleChoiceSpoergsmaal = delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex];
                    if (multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder === undefined) {
                        multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder = [];
                    }

                    multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder.push(multipleChoiceSvarmulighed);
                    this.setState(newState);
                }
            }
        }
    }

    onSvarmulighedChanged(fieldName: string, value: any, index: number, delopgaveIndex: number, multipleChoiceSpoergsmaalIndex: number) {
        let newState = this.state;
        if (newState.opgave !== undefined) {
            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                let delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex] !== undefined) {
                    let multipleChoiceSpoergsmaal = delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex];
                    if (multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder !== undefined) {

                        multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder[index][fieldName] = value;
                        this.setState(newState);
                    }
                }
            }
        }
    }

    removeSvarmulighed(index: number, delopgaveIndex: number, multipleChoiceSpoergsmaalIndex: number) {
        let newState = this.state;
        if (newState.opgave !== undefined && index > -1) {

            if (newState.opgave.delopgaver[delopgaveIndex] !== undefined) {
                let delopgave = newState.opgave.delopgaver[delopgaveIndex];
                if (delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex] !== undefined) {
                    let multipleChoiceSpoergsmaal = delopgave.multipleChoiceSpoergsmaal[multipleChoiceSpoergsmaalIndex];
                    if (multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder !== undefined) {

                        multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder.splice(index, 1);
                        this.setState(newState);
                    }
                }
            }
        }
    }

    onFileUpload(formData: FormData) {
        let self = this;
        this.setState({ isSubmitting: true });
        let opgave = this.getOpgave();

        createApiCaller().uploadImage(formData).then(fileId => {
            opgave.billedId = fileId;
            self.setState({ opgave: opgave, isSubmitting: false });
        });
    }

    getOpgave(): Opgave {
        let k = this.state.opgave;
        if (k === undefined) {
            throw new Error('opgave er undefined');
        }
        return k;
    }

    render() {
        if (this.state.isSaved === false) {
            if (this.props.location.pathname.indexOf('preview') > 0 && this.state.opgave !== undefined) {
                return <OpgavePreview opgave={this.state.opgave} />;
            } else {
                if ((this.state.opgave === undefined && !this.state.isNew)) {
                    return <Spinner />;
                } else {
                    return (
                        <PageWrapper>
                            <PageTitle title={'Opgaver'} />
                            <ContentWrapper>
                                <OpgaveEdit
                                    opgave={this.state.opgave === undefined ? new Opgave : this.state.opgave}
                                    onOpgaveSave={this.onOpgaveSave}
                                    onOpgaveChanged={this.onOpgaveChanged}
                                    onEditorChange={this.onOpgaveEditorChange}
                                    opgaveEditorState={this.state.OftestStilledeSpoergsmaalEditorState}
                                    // onOpgaveDelete={this.onOpgaveDelete}
                                    addAfsnit={this.addAfsnit}
                                    onAfsnitChanged={this.onAfsnitChanged}
                                    onAfsnitEditorChanged={this.onAfsnitEditorChange}
                                    afsnitEditorStates={this.state.afsnitEditorStates}
                                    removeAfsnit={this.removeAfsnit}
                                    addDelopgave={this.addDelopgave}
                                    onDelopgaveChanged={this.onDelopgaveChanged}
                                    onDelopgaveResultatEnumChanged={this.onDelopgaveResultatEnumChanged}
                                    onDelopgaveEditorChanged={this.onDelopgaveEditorChange}
                                    delopgaveEditorStates={this.state.delopgaveEditorStates}
                                    removeDelopgave={this.removeDelopgave}
                                    addSpoergsmaal={this.addSpoergsmaal}
                                    onSpoergsmaalChanged={this.onSpoergsmaalChanged}
                                    removeSpoergsmaal={this.removeSpoergsmaal}
                                    addSvarmulighed={this.addSvarmulighed}
                                    onSvarmulighedChanged={this.onSvarmulighedChanged}
                                    removeSvarmulighed={this.removeSvarmulighed}
                                    onFileUpload={this.onFileUpload}
                                    errorMessages={this.state.validationResult ? this.state.validationResult.errorMessages : []}
                                    isNew={this.state.isNew}
                                    isSubmitting={this.state.isSubmitting}
                                    location={this.props.location}
                                    match={this.props.match}
                                    history={this.props.history}
                                    removeBedoemmelsesFaktor={this.removeBedoemmelsesFaktor}
                                    addBedoemmelsesFaktor={this.addBedoemmelsesFaktor}
                                    onBedoemmelsesFaktorChanged={this.onBedoemmelsesFaktorChanged}
                                />
                            </ContentWrapper>
                        </PageWrapper>
                    );
                }
            }
        } else {
            return (
                <Redirect to='/opgaver' />
            );
        }
    }
}

export default OpgaveContainer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/OpgaveContainer.tsx